<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch">
      <template>
        <el-button type="warning" @click="handleBind">绑定监控</el-button>
      </template>
    </com-search>
    <com-table ref="table" :columns="columns" :defaultParams="defaultParams" :api="api">
      <template #operation="row">
        <el-button type="success" size="mini" @click="restartFireDevice(row.data)">重启</el-button>
        <el-button type="danger" size="mini" @click="unbandDevice(row.data)">解绑</el-button>
      </template>
    </com-table>
    <bind-dialog ref="bindRef" @update="update"></bind-dialog>
  </com-page>
</template>

<script>
import { getSuperviseDevices, restartFireDevice, unbandDevice } from '@/api/minitor'
import BindDialog from './components/bind-dialog'

export default {
  components: { BindDialog },

  props: {
    siteDefaultParams: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      api: getSuperviseDevices,
      defaultParams: {
        type: 2,
      },
      searchColumns: [
        {
          label: '设备名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '绑定时间',
          type: 'date',
          prop: 'date'
        }
      ],
      columns: [
        {
          label: '设备号',
          prop: 'sn'
        },
        {
          label: '设备名称',
          prop: 'name'
        },
        {
          label: '监控单位',
          prop: 'unit'
        },
        {
          label: '绑定网点',
          prop: 'refStoreName'
        },
        {
          label: '绑定人',
          prop: 'refBindUserName'
        },
        {
          label: '绑定时间',
          prop: 'bindTime'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation'
        }
      ]
    }
  },

  created() {
    this.defaultParams = {
      ...this.defaultParams,
      ...this.siteDefaultParams
    }
  },

  methods: {
    update() {
      this.$refs.table.getList()
    },
    handleBind() {
      const params = {
        type: 'created',
        refStore: this.siteDefaultParams.refStore
      }
      this.$refs.bindRef.open(params)
    },
    handleSearch(e) {
      const params = {
        ...e,
        queryBandTimeStart: e.beginTime,
        queryBandTimeEnd: e.endTime,
      }
      delete params.beginTime
      delete params.endTime
      this.$refs.table.search(params)
    },
    restartFireDevice(row) {
      this.$confirm('是否确认重启该设备?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: row.code
          }
          restartFireDevice(params).then((res) => {
            const { desc } = res
            this.$message.success(desc)
            this.update()
          })
        }).catch((err) => {})
    },

    unbandDevice(row) {
      this.$confirm('是否确认解绑该设备?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: row.code
          }
          unbandDevice(params).then((res) => {
            const { desc } = res
            this.$message.success(desc)
            this.update()
          })
        }).catch((err) => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.search_wrapper {
  width: 100%;
  padding: 20px;
  background: white;
  margin-bottom: 15px;
  border-radius: 5px;
}
</style>
